import clsx from 'clsx';
import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
export default function CommonSkeleton({
  className = 'w-[60vw] h-6',
  baseColor = '#c4c4c4',
  highlightColor = '#444',
}: {
  className?: string;
  baseColor?: string;
  highlightColor?: string;
}) {
  return (
    <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
      <Skeleton
        containerClassName={clsx('flex', className)}
        height="100%"
      />
    </SkeletonTheme>
  );
}
